<section class="card p-6 mb-6">
<!--                  grid-cols-4-->
    <div class="grid grid-cols-2 gap-6">

        <div class="col-span-4">
            <div class="flex justify-between">
                <h2 class="text-xl font-semibold">Team</h2>
                <app-edit-button *ngIf="edit" [edit]="edit"></app-edit-button>
            </div>
        </div>

        <!-- Size -->
        <div class="col-span-4 lg:col-span-2 xl:col-span-1">
            <h3 class="text-base font-semibold pb-6">Size</h3>

            <div class="mb-3">
                <span class="text-2xl font-bold">{{ company?.estimated_num_employees }}</span>
            </div>
        </div>

        <!-- / Specializations -->
        <!--
        <div class="hidden">
          <div class="col-span-4 lg:col-span-2 xl:col-span-1">
              <h3 class="text-base font-semibold pb-6">Specializations</h3>

              <div class="mb-3">
                  // chart
              </div>

              <div class="mb-3">
                  <div *ngFor="let specialization of company?.industries;" class="pills">
                          <span class="flex items-center text-xs text-secondary-900">
                              <span class="flex h-3 w-3 rounded-full mr-1"></span>
                              {{ specialization }}
                          </span>
                  </div>
              </div>

              <div class="blue-card p-3">
                  <p class="text-sm">// description</p>
              </div>
          </div>
        </div>
        -->
        <!-- / Specializations -->

        <!-- Open positions -->
        <!--
        <div class="hidden">
          <div class="col-span-4 lg:col-span-2 xl:col-span-1">
              <h3 class="text-base font-semibold pb-6">Open positions</h3>

              <div class="mb-3">
                  // chart
              </div>

              <div *ngIf="company?.jobs" class="mb-3">
                  <div class="text-sm mb-3">
                      Total: <span class="font-semibold">open positions total</span>
                  </div>
                  <div *ngFor="let openPosition of company?.open_positions; index as i;" class="pills">
                          <span class="flex items-center text-xs text-secondary-900">
                              <span class="flex h-3 w-3 rounded-full mr-1" [ngClass]="openPosition.class"></span>
                              {{ openPosition.name }} {{ openPosition.positions }}
                          </span>
                  </div>
              </div>

              <div class="blue-card p-3">
                  <p class="text-sm">open positions description</p>
              </div>
          </div>
        </div>
        -->
        <!-- / Open positions -->

        <!-- Areas of expertise -->
        <div *ngIf="company?.keywords?.length" class="col-span-4 lg:col-span-2 xl:col-span-1">
            <h3 class="text-base font-semibold pb-6">Areas of expertise</h3>

            <div class="mb-3">
                <div *ngFor="let keyword of company?.keywords" class="pills">
                      <span class="flex items-center text-xs text-secondary-900">
                          {{ keyword ?? '' }}
                      </span>
                </div>
            </div>
        </div>
        <!-- Areas of expertise -->

    </div>

</section>
